import { render, staticRenderFns } from "./MembersView.vue?vue&type=template&id=9b5987d2&"
import script from "./MembersView.vue?vue&type=script&lang=js&"
export * from "./MembersView.vue?vue&type=script&lang=js&"
import style0 from "./MembersView.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports